import newsletterConfig from '../../../newsletter-config.json'


export const tableProps = {
    border: 0,
    cellPadding: 0,
    cellSpacing: 0,
    width: '100%'
}

export const propContainerWidth = {
    width: newsletterConfig.bodyWith
}

export const tdProps = {
    align: 'center',
    valign: 'top',
}
